export default {
  concert1: ['【中国移动香港 Privilege Club呈献：', 'Hana 菊梓乔“只想与你在一起”演唱会】登记获取免费$680门票2张'],
  concert2: ['日期', '时间', '地点'],
  concert3: [[' 2019年8月24及25日', '(星期六及日)'], ['晚上8时15分正开始演唱会', '(晚上6时30分开始登记入场)'], ['九龙湾展贸径一号', '九龙湾国际展贸中心3楼', '汇星Star Hall']],
  concert4: '注意事项',
  concert5: ['登记换领『中国移动香港Privilege Club呈献: Hana菊梓乔“只想与你在一起”演唱会』免费门票，名额有限。每位合资格Privilege Club 会员/特选客户可带同一名亲友参加。如活动当日多于一位亲友到场，该名亲友将会不被安排入场。\n',
    '须填妥以下表格以作活动的登记、核对及联络之用。\n',
    '中国移动香港会挑选上述问题 “您最想同哪一位一同欣赏Hana菊梓桥演唱会?原因为何? ”中，有创意的客户送出演唱会门票，每位客户2张 (名额100个)。门票数量有限，送完即止。活动截止登记日期为2019年7月28日。',
    '成功获邀参与之客户将于2019年8月7日经MyLink App收到活动确认通知。如于此日期前未有收到活动确认通知，即不获邀请参与此活动。\n',
    '成功获邀参与之客户请于活动当日向在场工作人员出示于MyLink App内的活动确认通知，及开启换票证页面，以作兑换演唱会门票及入场之用。\n',
    '座位安排以活动当日先到先得的形式分配，所兑换的门票不设座位选择。\n',
    '成功获邀参与之客户须于指定时间到达指定地点参与活动，逾时不候并视为自行放弃参与是次活动之权利。\n',
    '参加者同意并授权中国移动香港、星梦娱乐集团有限公司及Event Elite Production and Promotion Limited使用其参加活动的花絮照片及影片作宣传用途，而恕不另行通知。\n',
    '参加者同意并授权中国移动香港及Event Elite Production and Promotion Limited使用其个人资料，透过并不限于以手机短讯/智能手机讯息、电话及电邮等方式作『中国移动香港Privilege Club呈献: Hana菊梓乔“只想与你在一起”演唱会』联络及入场登记用途。\n',
    '如有任何争议，中国移动香港、星梦娱乐集团有限公司及Event Elite Production and Promotion Limited将保留最终决定权。\n',
    '如有任何查询，请致电客户服务热线2945 8888。'],
  concert6: '客户姓名',
  concert7: '中国移动香港流动电话号码 （亦作联络之用）',
  concert8: '电邮地址',
  concert9: '您希望出席哪一场演唱会？',
  concert10: ['24/08/2019 (六)', '25/08/2019 (日)'],
  concert11: '条款及细则',
  concert12: ['本人同意及知悉所提供的', '条款及细则', '和', '私隐政策声明'],
  concert14: '您已完成登记！',
  concert15: '注意：此表格只作登记用途，并不代表获邀参与。',
  concert16: '成功登记并获邀参与活动之客户，将于8月7日或之前于MyLink App收到免费获取演唱会门票活动结果。',
  concert17: '在场工作人员输入4位数字以兑换演唱会门票\n',
  concert18: ['演唱会换票证只限所列日子当天使用，逾期无效。\n',
    '每张换票证只可使用一次并供一位客户使用。如活动当日多于一位亲友到场，该名亲友将会不被安排入场。\n',
    '客户需于活动当日向在场工作人员出示于MyLink App内的活动确认通知，及开启换票证页面，以作兑换演唱会门票及入场之用。不接受以MyLink App以外的形式以出示换票证。\n',
    '座位安排以先到先得的形式分配，不设选择座位。\n',
    '获邀之客户须于指定时间到达指定地点参与活动，逾时不候并视为自行放弃参与是次活动之权利。\n',
    '换票证不可作转让、转售或换取其他服务之用途。\n',
    '如天文台于活动开始前两小时发出八号或以上之台风警告信号；或黑色暴雨警告信号，活动将延期举行。如悬挂三号风球以下或黄/红色暴雨警告信号，活动将如期举行。详情请留意中国移动香港网站。\n',
    '参加者同意并授权中国移动香港、星梦娱乐集团有限公司及Event Elite Production and Promotion Limited使用其参加活动的花絮照片及影片作宣传用途，而恕不另行通知。\n',
    '参加者同意并授权中国移动香港及Event Elite Production and Promotion Limited使用其个人资料，透过并不限于以手机短讯/智能手机讯息、电话及电邮等方式作『中国移动香港Privilege Club呈献: Hana菊梓乔“只想与你在一起”演唱会』联络及入场登记用途。\n',
    '如有任何争议，中国移动香港、星梦娱乐集团有限公司及Event Elite Production and Promotion Limited将保留最终决定权。\n',
    '如有任何查询，请致电客户服务热线2945 8888。'],
  concert19: '后补名单通知',
  concert20: '获取免费演唱会门票活动',
  concert21: '后补名单通知',
  concert22: ['感谢阁下登记!', '由于反应热烈，是次活动名额已满,',
    '您的登记会被列作后补名额，成功后补的客户将于活动前1至2天收到电话通知。',
    '如有任何争议，中国移动香港保留一切最终之决定权。',
    '如有任何查询，请致电客户服务热线2945 8888。'],
  concert23: '活动确认通知',
  concert24: '成功获取演唱会门票2张',
  concert25: '按此获取换票证',
  concert26: '即场兑换门票',
  concert27: '换票证',
  concert28: '活动详情',
  concert29: '抱歉 ! 您未符合参与是次活动的资格',
  concert30: '返回主页',
  concert31: '立即报名',
  concert32: '报名表格',
  concert33: '提交',
  concert34: '完成登记',
  concert35: '提交',
  concert36: '您最想同哪一位一同欣赏Hana菊梓乔演唱会？原因为何？（有创意的客户将有机会获得免费演唱会2张门票，每位客户2张，名额100个)',
  concert37: '换领码不正确，请再输入',
  concert38: '400字内',
  concert39: '页面无效，请按返回。',
  concert40: ['获取免费演唱会门票', '报名活动已结束']
}


// WEBPACK FOOTER //
// ./src/locale/concert/zh-cn.js